export default __webpack_public_path__ + "static/media/ry-pert.6951f062.png";